import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";

import { AjaxResult } from "../../../../../enums/ajaxResult";
import { useApi } from "../../../../useApi";

export function useChangeLeaseEndDate(boxId: number) {
    const { leaseApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const changeLeaseEndDate = useCallback((
        date: Date | null | undefined,
        onSuccess: () => void,
    ) => {
        setLoading(true);
        leaseApi.changeLeaseEndDate(boxId, date).then((r) => {
            if (r.result === AjaxResult.Success) {
                enqueueSnackbar("Lease end date saved!", { variant: "success" });
                onSuccess();
            } else if (r.result === AjaxResult.Forbidden) {
                enqueueSnackbar(
                    "You do not have permission to edit this box's lease!",
                    { variant: "error" },
                );
            } else {
                enqueueSnackbar("Failed to save lease end date!", { variant: "error" });
            }
            setLoading(false);
        });
    }, [leaseApi, boxId, enqueueSnackbar]);

    return { changeLeaseEndDate, loading };
}
